var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M17.01 8H10V10H17.01V13L21 9L17.01 5V8ZM3 15L6.99 19V16H14V14H6.99V11L3 15Z","fill":"#707070"}})}
var staticRenderFns = []

export { render, staticRenderFns }